export const SIGNAL_TYPE = {
    DIGITAL_SIGNAL: 1,
    ANALOG_SIGNAL: 2,
    VIDEO_SIGNAL: 3,
}

export function getSignalTypeName(type: number) {
    if (type === SIGNAL_TYPE.DIGITAL_SIGNAL) {
        return "数字信号"
    } else if (type === SIGNAL_TYPE.ANALOG_SIGNAL) {
        return "模拟信号"
    } else if (type === SIGNAL_TYPE.VIDEO_SIGNAL) {
        return "视频信号"
    }
    return ''
}

export const SIGNAL_TYPE_LIST = [
    { value: SIGNAL_TYPE.DIGITAL_SIGNAL, label: '数字信号' },
    { value: SIGNAL_TYPE.ANALOG_SIGNAL, label: '模拟信号' },
    { value: SIGNAL_TYPE.VIDEO_SIGNAL, label: '视频信号' },
]